export default {
  getUuid () {
    return this.getyyyyMMdd() + 'xxxxxxxx'.replace(/[x]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    })
  },
  getyyyyMMdd () {
    const now = new Date()
    return [now.getFullYear(),
    now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1,
    now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
    ].join('');
  },
  // 时间戳to  y-m-d
  riQi: function (sj) {
    var now = new Date(sj);
    var year = now.getFullYear();
    var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1;
    var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
    var hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours();
    var minute = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes();
    var second = now.getSeconds();
    var allData = year + "-" + month + "-" + date;
    return allData;

  },
  // 时间戳to  y-m-d h:m
  riQi2: function (sj) {
    var now = new Date(sj);
    var year = now.getFullYear();
    var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1;
    var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
    var hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours();
    var minute = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes();
    var second = now.getSeconds();
    var alldata2 = year + "-" + month + "-" + date + "  " + hour + ":" + minute;
    return alldata2;

  },
  //Date to  y-m-d
  riQi3: function (now) {
    var year = now.getFullYear();
    var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1;
    var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
    var hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours();
    var minute = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes();
    var second = now.getSeconds();
    var allData = year + "-" + month + "-" + date;
    return allData;

  },
  //Date to  y-m-d h:m
  riQi4: function (now) {
    var year = now.getFullYear();
    var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1;
    var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
    var hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours();
    var minute = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes();
    var second = now.getSeconds();
    var alldata2 = year + "-" + month + "-" + date + "  " + hour + ":" + minute;
    return alldata2;

  },
  //Date to  y-m-d h:m:s
  riQi5: function (sj) {
    var now = new Date(sj);
    var year = now.getFullYear();
    var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1;
    var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
    var hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours();
    var minute = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes();
    var second = now.getSeconds();
    var alldata2 = year + "-" + month + "-" + date + "  " + hour + ":" + minute + ":" + second;
    return alldata2;

  },
  //Date to  y-m-d h:m:s
  riQi6: function (sj) {
    var now = new Date(sj);
    var year = now.getFullYear();
    var month = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1;
    var date = now.getDate() < 10 ? '0' + now.getDate() : now.getDate();
    var hour = now.getHours() < 10 ? '0' + now.getHours() : now.getHours();
    var minute = now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes();
    var second = now.getSeconds();
    var alldata2 = year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
    return alldata2;

  },

  // Date to  y-m-d
  riQi7: function (sj) {
    var date = sj.split(' ')[0];
    return date;
  },

  // Date to  y-m-d
  riQi8: function (sj) {
    sj = String(sj);
    if (sj !== null && sj !== '') {
      if (sj.length === 8) {
        sj = sj.replace(/(.{4})(.{2})(.{2})/, '$1-$2-$3')
      } else if (sj.length === 6) {
        sj = sj.replace(/(.{4})(.{2})/, '$1-$2')
      }
    }
    return sj
  },
  addDays (date, days) {
    const result = new Date(date)
    result.setDate(result.getDate() + days)
    return result
  },
  formatDate (date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从 0 开始
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  },
}
